module.exports = __webpack_public_path__ + "media/145.79fb81d8.wav";